<template>
  <Users
    :users="users"
    :user-roles="userRoles"
    :password-min-length="passwordMinLength"
    :user-added="userAdded"
    @addUser="addNewUser" />
</template>
<script>
import { mapState, mapActions } from 'vuex';
import Users from './_components/Users.vue';

export default {
  name: 'UsersModule',
  components: {
    Users,
  },
  computed: {
    ...mapState('user', {
      users: state => state.users,
      userRoles: state => state.userRoles,
      passwordMinLength: state => state.passwordMinLength,
    }),
  },
  data() {
    return {
      userAdded: false,
    };
  },
  created() {
    this.fetchUsers();
    this.subscribeToUserAdded();
    this.subscribeToUserUpdated();
  },
  beforeDestroy() {
    this.unsubscribeToUserAdded();
    this.unsubscribeToUserUpdated();
  },
  methods: {
    ...mapActions('user', [
      'fetchUsers',
      'subscribeToUserAdded',
      'subscribeToUserUpdated',
      'unsubscribeToUserUpdated',
      'unsubscribeToUserAdded',
      'addUser',
    ]),
    async addNewUser(user) {
      await this.addUser(user);
      this.userAdded = true;
    },
  },
};
</script>
